import Sm from './Sm.vue'
import module from './store'
import { createTargetDefinitionWatcher } from './store/watchers'
import { createStoreConnector } from '@/store'

const unwatchers = []

export default createStoreConnector('sm', module('sm'), {
  onRegistered: store => {
    unwatchers.push(createTargetDefinitionWatcher(store))
  },
  onUnregistered: () => {
    unwatchers.forEach(unwatcher => unwatcher.call())
  }
})(Sm)



// WEBPACK FOOTER //
// ./src/app/views/workbench/SM/index.js